import {LoadPhotoswipe} from './load-photoswipe';

const selectors = {
  videoPlay: '[data-video-play]',
  videoPlayValue: 'data-video-play',
};

class VideoPlay {
  constructor(section) {
    this.container = section;
    this.videoPlay = this.container.querySelector(selectors.videoPlay);

    if (this.videoPlay) {
      this.videoPlay.addEventListener('click', function (e) {
        if (this.hasAttribute(selectors.videoPlayValue) && this.getAttribute(selectors.videoPlayValue).trim() !== '') {
          e.preventDefault();

          const items = [
            {
              html: this.getAttribute(selectors.videoPlayValue),
            },
          ];

          new LoadPhotoswipe(items);
        }
      });
    }
  }
}

const videoPlay = {
  onLoad() {
    new VideoPlay(this.container);
  },
};

export default videoPlay;
